import { useSyncExternalStore } from "react";
/** Подписка на CSS media query (SSR snapshot = false). */
export function useMediaQuery(query) {
    return useSyncExternalStore((onChange) => {
        const mq = window.matchMedia(query);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, () => window.matchMedia(query).matches, () => false);
}
